
/**
 * Defined structure for cookie consent data.
 * @export
 * @class CookieConsent
 */
export default class CookieConsent {
    /**
     * Creates an instance of CookieConsent.
     * @param {Object} data The part index.
     * @memberof CookieConsent
     */
    constructor(data = null) {
        /**
         * @type {boolean}
         */
        this.analytics = data && data.analytics || false

        /**
         * @type {boolean}
         */
        this.appCore = data && data.appCore || false

        /**
         * @type {boolean}
         */
        this.setByUser = data !== null
    }

    /**
     * Returns the object in a form suitable to store.
     * @memberof CookieConsent
     */
    toStoreJson() {
        return {
            analytics: this.analytics,
            appCore: this.appCore,
        }
    }
}
